import { render, staticRenderFns } from "./saleOrderDeliveryIcon.vue?vue&type=template&id=2ac33272&scoped=true"
import script from "./saleOrderDeliveryIcon.vue?vue&type=script&lang=js"
export * from "./saleOrderDeliveryIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ac33272",
  null
  
)

export default component.exports